module.exports = __webpack_public_path__ + "static/media/CircuralActive.3b5fcb13.svg";